import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Link as MUILink,
  Typography,
} from "@mui/material";

import LoadingButton from "@/components/loaders/LoadingButton";
import RpMUIModal from "@/components/modals/RpMUIModal";

const UserManagementTermsGate = ({ open, onAccept, isLoading = false }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();
      if (!isChecked) return;
      onAccept();
    },
    [isChecked, onAccept]
  );

  return (
    <RpMUIModal open={open} persists maxWidth="sm">
      <Box
        component="form"
        onSubmit={handleSubmit}
        className="text-center px-4 px-sm-5 py-5"
      >
        <Typography variant="h5" className="text-center font-weight-bold mb-3">
          We've Updated Our Terms
        </Typography>
        <Typography variant="body2" className="text-center mb-2">
          We&apos;ve made some tweaks to how we handle data and services.
        </Typography>
        <MUILink
          variant="body2"
          className="text-center d-inline-block font-weight-bold"
          color="primary"
          href="https://hyperlocology.com/user-terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
        >
          See Terms and conditions
        </MUILink>

        <Box className="text-center my-4">
          <FormControlLabel
            className="m-0"
            control={
              <Checkbox
                className="p-0 mr-2"
                checked={isChecked}
                onChange={(event) => setIsChecked(event.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography variant="body2">
                I agree with the new terms and conditions
              </Typography>
            }
          />
        </Box>

        <LoadingButton
          className="w-100 font-weight-bold mt-2"
          disabled={!isChecked}
          isLoading={isLoading}
          text="Accept and Continue"
          type="submit"
        />
      </Box>
    </RpMUIModal>
  );
};

UserManagementTermsGate.propTypes = {
  open: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default UserManagementTermsGate;
